module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__body"
  }, [_c('div', {
    staticClass: "Settings__body-container"
  }, [_c('div', {
    staticClass: "Settings__title"
  }, [_vm._v("\n      Settings\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__inner-container"
  }, [_c('img', {
    directives: [{
      name: "fallback-src",
      rawName: "v-fallback-src",
      value: ('../../../../static/images/default-user-avatar.jpg'),
      expression: "'../../../../static/images/default-user-avatar.jpg'"
    }],
    staticClass: "Settings__profile",
    attrs: {
      "src": _vm.getUserInfo(_vm.user.userId).avatarUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__name"
  }, [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__username"
  }, [_vm._v("\n        @" + _vm._s(_vm.user.username) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__logout-btn",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n        logout\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__rows-container"
  }, [_c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info Settings__account-status",
    class: _vm.subscription.active ? 'pro' : 'free'
  }, [_c('i', {
    staticClass: "icon-ic_star Settings__row-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-info-text"
  }, [_c('span', {
    staticClass: "Settings__account-status--free"
  }, [_vm._v("FREE USER")]), _vm._v(" "), _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("PRO USER")]), _vm._v(" "), (_vm.subscription.autoRenewing) ? _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("\n                Next renewal date: " + _vm._s(_vm._f("moment")(_vm.subscription.expireTimeMillis, "MMMM DD, YYYY")) + "\n              ")]) : _c('span', {
    staticClass: "Settings__account-status--pro"
  }, [_vm._v("\n                Expire date: " + _vm._s(_vm._f("moment")(_vm.subscription.expireTimeMillis, "MMMM DD, YYYY")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-action",
    on: {
      "click": _vm.toggleUpgradeMenu
    }
  }, [(!_vm.subscription.active) ? _c('span', [_vm._v("UPGRADE FOR FREE*")]) : _vm._e(), _vm._v(" "), _c('upgrade-dropdown', {
    attrs: {
      "is-open": _vm.showUpgradeMenu
    },
    on: {
      "update:isOpen": function($event) {
        _vm.showUpgradeMenu = $event
      },
      "update:is-open": function($event) {
        _vm.showUpgradeMenu = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info"
  }, [_c('i', {
    staticClass: "icon-ic_lock Settings__row-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-info-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.user.conferencePin))]), _vm._v(" "), _c('span', [_vm._v("PIN")])])]), _vm._v(" "), _c('div', {
    staticClass: "Settings__row-action",
    on: {
      "click": _vm.changePin
    }
  }, [_vm._v("\n            CHANGE\n          ")])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('set-conference-url'), _vm._v(" "), _c('set-conference-pin'), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": "KingsConference - Settings"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__row"
  }, [_c('div', {
    staticClass: "Settings__row-info"
  }, [_c('i', {
    staticClass: "icon-ic_help Settings__row-icon"
  }), _vm._v(" "), _c('a', {
    staticClass: "Settings__row-action",
    attrs: {
      "href": "mailto:kingsconference@joinkingschat.com"
    }
  }, [_vm._v("\n              GET HELP\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Settings__footer"
  }, [_vm._v("\n    By using the KingsPay platform, you are agreeing to our\n    "), _c('a', {
    staticClass: "Settings__footer-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.kingsch.at/kingsconference/privacy"
    }
  }, [_vm._v("\n      Terms of Service\n    ")]), _vm._v(",\n    "), _c('a', {
    staticClass: "Settings__footer-link",
    attrs: {
      "target": "_blank",
      "href": "https://www.kingsch.at/kingsconference/privacy"
    }
  }, [_vm._v("\n      Acceptable Use Policy & Privacy Policy\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-155d6749","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/settings-tab/settings-tab.vue
// module id = 431
// module chunks = 1